import React, { useState } from 'react'
import { Table } from 'antd'
import { View } from 'styles/reactnative'
import { AdminUserModal } from 'app/components'
import { AdminPopUpColumns } from './AdminPopUpColumns'
import { usePopUp } from 'app/hooks/AdminSettings/popUp'

const AdminPopUpTable = () => {
	const [showModal, setShowModal] = useState(false)
	const [selectedData, setSelectedData] = useState({})
	const [page, setPage] = useState(1)
	const [sort, setSort] = useState(false)
	const { data, mutate } = usePopUp()
	const openModal = () => {
		if (selectedData) {
			setShowModal(true)
		}
	}

	const pagination = {
		pageSize: 20,
		total: data?.count,
		current: page,
		onChange: (pageNumber: number) => {
			setPage(pageNumber)
			mutate(pageNumber)
		},
	}
	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter) {
			setSort(!sort)
		}
	}
	const rowSelection = {
		onChange: (selectedRowKeys: React.Key[], selectedRows) => {},
		getCheckboxProps: record => ({
			disabled: record.title === 'Disabled User',
			name: record.title,
		}),
	}
	const onRow = (e: any, record: any) => {
		setSelectedData(record?.id)
	}

	const footer = () => <div>{data?.list?.length}</div>
	return (
		<View style={{ width: '100%' }}>
			<Table
				rowSelection={{
					type: 'checkbox',
					...rowSelection,
					checkStrictly: false,
				}}
				onRow={record => ({ onClick: e => onRow(e, record) })}
				columns={AdminPopUpColumns(openModal)}
				dataSource={data?.list?.map(device => ({
					...device,
					key: device.id,
				}))}
				onChange={handleTableChange}
				scroll={{ x: 500 }}
				pagination={pagination}
				footer={footer}
				style={{ width: '100%' }}
			/>
			<AdminUserModal
				showModal={showModal}
				setShowModal={setShowModal}
				selectedData={selectedData}
			/>
		</View>
	)
}

export default AdminPopUpTable
